// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React, { PureComponent } from 'react';
import { pick } from 'lodash';

import { Avatar } from '@zapier/common-components';

import TeamLogo from 'web-ssr/app/common/components/TeamLogo';

type Props = {
  isTeam?: boolean,
  url: string,
  name: string,
  className?: string,
  size?: number,
};

export default class extends PureComponent<Props> {
  static defaultProps = {
    isTeam: false,
    size: 32,
  };

  render() {
    const { props } = this;
    const { isTeam } = props;
    const sharedProps = pick(props, ['url', 'className', 'size', 'name']);

    return isTeam ? <TeamLogo {...sharedProps} /> : <Avatar {...sharedProps} />;
  }
}
